import { ReactNode } from 'react';
export default function DialogTitle({children}: {children?:ReactNode;[key:string]:any}) {return <>{children}</>;}
